import http from '../http-common';

class MediaHistoryService {
  getAll() {
    return http.get("/media-history-report");
  }

  getAllMediaFilterHistory(start_date, end_date){
    return http.get(`/media-history-report?start_date=${start_date}&end_date=${end_date}`)
  }

  getById(id) {
    return http.get(`/media-history/edit/${id}`);
  }

  create(data) {
    return http.post("/area/add", data);
  }

  update(data) {
    return http.put(`/area/update`, data);
  }
  delete(id) {
    return http.put(`/area/delete/${id}`);
  }
}

export default new MediaHistoryService();
